import ConfiguredLimitsFactory from "../../factories/ConfiguredLimitsFactory";
import ConfiguredLimitsActions from "./ConfiguredLimitsActions";
import ConfiguredLimitsMutations from "./ConfiguredLimitsMutations";

const state = ConfiguredLimitsFactory.EmptyState();

const { actions } = ConfiguredLimitsActions;

const { mutations } = ConfiguredLimitsMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	namespaced,
};